const labs = {
    features: [],
    featuresByTenant: [],
    timelineEnabled: false
};

export default labs;
